<template>

  <v-main class="content-page-bg">

    <v-container v-if="item" fluid>

      <!-- ITEM SAMARY -->
      <v-row class="px-2">
        <v-col cols="12">

          <v-card color="#FE0A63" theme="white">

            <div class="d-flex flex-no-wrap justify-space-between">

              <div>

                <v-card-title v-if="isMobile && item.metadata.data.details.name.length > 25"
                  class="text-h5 mx-1 info-animated">
                  <h1 class="d-inline-block text-16" style="max-width: 150px;">{{ item.metadata.data.details.name }}
                  </h1>
                </v-card-title>

                <v-card-title v-else class="text-h5">
                  <h1 :class="['d-inline-block', isMobile ? 'text-16' : 'text-h5']"
                    :style="{ 'max-width: 150px': isMobile }">{{ item.metadata.data.details.name }}</h1>
                </v-card-title>


                <v-card-subtitle class="font-weight-bold">درباره بازیگر</v-card-subtitle>

                <v-card-actions class="mt-2">
                  <v-btn
                    v-if="!isPlaying || isPlaying && this.getCurrentAlbum.hash_id != this.currentTrack.albums[0].hash_id"
                    @click="updateTrack(getCurrentAlbum.tracks[0], getCurrentAlbum.tracks, true)"
                    class="ms-2 bg-ply-btn-info" icon="mdi-play" variant="text"></v-btn>
                  <v-btn v-else @click="pauseTrack" class="ms-2 bg-ply-btn-info" icon="mdi-pause"
                    variant="text"></v-btn>
                </v-card-actions>

                <!-- <v-card-actions>
                              <v-btn size="small" color="#A3A3A3" variant="text" icon="mdi-heart"></v-btn>
                              <v-btn size="small" color="#A3A3A3" variant="text" icon="mdi-share-variant"></v-btn>
                          </v-card-actions> -->
              </div>


              <v-avatar class="ma-2" :size="castImageSize()">
                <v-img :alt="`بیوگرافی ${item.metadata.data.details.name}`"
                  :src="item.thumbnail.link" class="rounded"></v-img>
              </v-avatar>

            </div>

          </v-card>
        </v-col>
      </v-row>
      <!-- ITEM SAMARY -->

      <!-- DETAILS -->
      <v-row class="px-2">
        <v-col cols="12">
          <v-card class="w-100 text-white shadow-none" color="#262626" variant="elevated">

            <v-card-item>
              <div>
                <div :class="['mb-2']">
                  جزئیات
                </div>

                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>نام اصلی:</b> {{
                  item.metadata.data.details.native_name }} </p>
                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>نام های دیگر:</b> {{
                  item.metadata.data.details.known_as }} </p>
                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>ملیت:</b> {{
                  item.metadata.data.details.nationality }} </p>
                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>جنسیت:</b> {{ item.metadata.data.details.genres
                  }} </p>
                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>تولد:</b> {{ item.metadata.data.details.born }}
                </p>

              </div>
            </v-card-item>

          </v-card>
        </v-col>
      </v-row>
      <!-- DETAILS -->

      <!-- MORE INFO -->
      <v-row class="px-2" v-if="item.fa_description">
        <v-col cols="12">

          <v-card class="w-100 text-white shadow-none" color="#262626" variant="elevated">

            <v-card-item>
              <div>
                <div :class="['mb-2']">
                  بیوگرافی
                </div>
                <div class="text-caption">{{ item.metadata.data.description }}</div>
              </div>
            </v-card-item>

          </v-card>
        </v-col>
      </v-row>
      <!-- MORE INFO -->

      <v-col v-if="isMobile" class="mx-auto my-1" cols="8">
        <a :href="settings.telegram_chanel_url" target="_blank" class="w-100">
          <v-img alt="کانال تلگرام کره فای"
            :class="['w-100']" :src="settings.telegram_banner_url"></v-img>
        </a>
      </v-col>

      <!-- OSTs -->
      <div v-if="isMobile && item.albums.length > 0">
        <card-slide
          v-bind="{ items: item.albums, title: 'آلبوم های OST', type: 'album', shape: 'square', aspectRatio: '1.0', moreLink: false, cardBg: '#282828' }"></card-slide>
      </div>

      <div v-else-if="!isMobile && item.albums.length > 0">
        <card-list
          v-bind="{ items: item.albums, title: 'آلبوم های OST', type: 'album', shape: 'square', aspectRatio: '1.0', moreLink: false, cardBg: '#282828' }"></card-list>
      </div>
      <!-- OSTs -->

      <!-- DRAMAs -->
      <v-row class="my-4 px-2" v-if="item.metadata.data.dramas.length > 0">
        <v-card class="w-100 text-white shadow-none mx-2" color="#262626" variant="elevated">
          <v-card-item>
            <div :class="['mb-4 h5']">
              <h2 class="mobile-sub-section">لیست دراما ها </h2>
              <!-- <p class="album-detail font-italic text-grey-lighten-2 px-1">لیست دراما های {{ item.name }}</p> -->
            </div>
            <v-table theme="dark" fixed-header dir="ltr">
              <thead>
                <tr>
                  <th class="text-left">
                    نام
                  </th>
                  <th class="text-left">
                    سال
                  </th>
                  <th class="text-left">
                    نقش
                  </th>
                  <th class="text-left">
                    امتیاز
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(drama, index) in item.metadata.data.dramas" :key="index">
                  <td>{{ drama.title }}</td>
                  <td>{{ drama.year }}</td>
                  <td>{{ drama.role }}</td>
                  <td>{{ drama.rate }}</td>
                </tr>
              </tbody>
            </v-table>
          </v-card-item>

        </v-card>
      </v-row>
      <!-- DRAMAs -->

      <!-- MOVIES -->
      <v-row class="my-4 px-2" v-if="item.metadata.data.movies.length > 0">
        <v-card class="w-100 text-white shadow-none mx-2" color="#262626" variant="elevated">
          <v-card-item>
            <div :class="['mb-4 h5']">
              <h2 class="text-white mobile-sub-section">فیلم ها</h2>
              <!-- <p class="text-caption font-italic text-grey-lighten-2">{{ item.name }} Movies List / {{ item.name }} Old & New Movies</p> -->
            </div>
            <v-table theme="dark" fixed-header dir="ltr">
              <thead>
                <tr>
                  <th class="text-left">
                    نام
                  </th>
                  <th class="text-left">
                    سال
                  </th>
                  <th class="text-left">
                    نقش
                  </th>
                  <th class="text-left">
                    امتیاز
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(drama, index) in item.metadata.data.movies" :key="index">
                  <td>{{ drama.title }}</td>
                  <td>{{ drama.year }}</td>
                  <td>{{ drama.role }}</td>
                  <td>{{ drama.rate }}</td>
                </tr>
              </tbody>
            </v-table>
          </v-card-item>

        </v-card>
      </v-row>
      <!-- MOVIES -->

      <!-- Tv shows -->
      <v-row class="my-4 px-2" v-if="item.metadata.data.tv_shows.length > 0">
        <v-card class="w-100 text-white shadow-none mx-2" color="#262626" variant="elevated">
          <v-card-item>
            <div :class="['mb-4 h5']">
              <h2 class="text-white mobile-sub-section">نمایش های تلویزیونی</h2>
              <!-- <p class="text-caption font-italic text-grey-lighten-2">{{ item.name }} TV Shows</p> -->
            </div>
            <v-table theme="dark" fixed-header dir="ltr">
              <thead>
                <tr>
                  <th class="text-left">
                    نام
                  </th>
                  <th class="text-left">
                    سال
                  </th>
                  <th class="text-left">
                    نقش
                  </th>
                  <th class="text-left">
                    امتیاز
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(drama, index) in item.metadata.data.tv_shows" :key="index">
                  <td>{{ drama.title }}</td>
                  <td>{{ drama.year }}</td>
                  <td>{{ drama.role }}</td>
                  <td>{{ drama.rate }}</td>
                </tr>
              </tbody>
            </v-table>
          </v-card-item>

        </v-card>
      </v-row>
      <!-- Tv shows -->


      <!-- specials -->
      <!-- <v-row class="my-2 px-2" v-if="item.metadata.data.specials.length > 0">
        <v-card class="w-100 text-white shadow-none mx-2" color="#262626" variant="elevated">
          <v-card-item>
            <div :class="['mb-4 h5']">
              <h2 class="text-white mobile-sub-section">Specials</h2>
              <p class="text-caption font-italic text-grey-lighten-2">{{ item.name }} Specials</p>
            </div>
            <v-table theme="dark" fixed-header>
              <thead>
                <tr>
                  <th class="text-left">
                    Name
                  </th>
                  <th class="text-left">
                    Year
                  </th>
                  <th class="text-left">
                    Role
                  </th>
                  <th class="text-left">
                    Rate
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(drama, index) in item.metadata.data.specials" :key="index">
                  <td>{{ drama.title }}</td>
                  <td>{{ drama.year }}</td>
                  <td>{{ drama.role }}</td>
                  <td>{{ drama.rate }}</td>
                </tr>
              </tbody>
            </v-table>
          </v-card-item>

        </v-card>
      </v-row> -->
      <!-- specials -->


    </v-container>
  </v-main>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { getCast } from '@/api'
import { replaceChars } from '@/helpers';
import store from '@/store';

export default {

  data() {
    return {
      hashId: null,
      dialog: false,
      item: null
    }
  },

  components: {

    CardList: defineAsyncComponent(() =>
      import('./includes/CardList.vue')
    ),

    CardSlide: defineAsyncComponent(() =>
      import('./includes/CardSlide.vue')
    )
  },

  computed: {

    //get current props of player
    playerProps() {
      return this.$store.getters.getPlayerProps
    },

    settings() {
      return this.$store.getters.settings;
    },


    getCurrentAlbum() {
      return this.$store.getters.getCurrentAlbum
    },

    isMobile() {
      return this.$store.getters.getIsMobile;
    },

    currentTracks() {
      return this.$store.getters.getCurrentTracks
    },

    currentTrack() {
      return this.$store.getters.getCurrentTrack
    },


    //track is playing or not
    isPlaying() {
      return this.$store.getters.getPlayerProps.isPlaying
    },


  },

  methods: {

    updateTrack(track, tracklist, play = false) {
      this.$store.commit('setTrack', { trackObj: track, listObj: tracklist, play: play })
    },

    //play a track
    palyTrack() {

      //check player src is empty or not. if it was empty , first set a src for player and then play audio
      if (!this.playerProps.src) {

        this.updateTrack(this.currentTrack, this.currentTracks)
      }

      this.$store.commit('setPlayerPlay');
    },

    castImageSize() {
      if (this.isMobile) {
        return '120';
      } else {
        return '150';
      }
    },

    pauseTrack() {
      this.$store.commit('setPlayerPause');
    },

    setCurrentAlbumAsync(album) {
      this.$store.dispatch('setCurrentAlbumAsync', album);
    },

    setCurrentTrackAsync(track) {
      this.$store.dispatch('setCurrentTrackAsync', track);
    },

    setCurrentTracksAsync(tracks) {
      this.$store.dispatch('setCurrentTracksAsync', tracks);
    },

    async fetchCastData() {

      var castResponse = await getCast(this.$route.params.slug)

      //check response
      if (castResponse.ok == true) {

        this.item = castResponse.data

        if (this.item) {

          store.commit('setCurrentComponent', this.item.page_title)

          if (!this.isPlaying) {
            document.title = this.item.page_title
          }

        }

        //set album info in state management
        const randomIndex = Math.floor(Math.random() * castResponse.data.albums.length);
        this.setCurrentAlbumAsync(castResponse.data.albums[randomIndex]);

        if (!this.currentTracks) {
          this.setCurrentTracksAsync(castResponse.data.albums[randomIndex].tracks);
          this.setCurrentTrackAsync(castResponse.data.albums[randomIndex].tracks[0])
        }
      }

    },

    parseUrlChars(val) {
      return replaceChars(val)
    },
  },

  watch: {

    async $route(to, from) {

      if (to.name == from.name && to.params.slug !== from.params.slug) {

        window.scrollTo(0, 0)
        await this.fetchCastData();

      }

    },
  },


  async created() {
    await this.fetchCastData();
  }
};

</script>

<style></style>